/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export const prefix = 'api-';
export const spaPrefix = prefix + 'ixn-';
export const ADD_PAGE_ACTION = 'addPageAction';
export const ADD_TO_TRACE = 'addToTrace';
export const ADD_RELEASE = 'addRelease';
export const FINISHED = 'finished';
export const INTERACTION = 'interaction';
export const LOG = 'log';
export const NOTICE_ERROR = 'noticeError';
export const PAUSE_REPLAY = 'pauseReplay';
export const RECORD_CUSTOM_EVENT = 'recordCustomEvent';
export const RECORD_REPLAY = 'recordReplay';
export const REGISTER = 'register';
export const SET_APPLICATION_VERSION = 'setApplicationVersion';
export const SET_CURRENT_ROUTE_NAME = 'setCurrentRouteName';
export const SET_CUSTOM_ATTRIBUTE = 'setCustomAttribute';
export const SET_ERROR_HANDLER = 'setErrorHandler';
export const SET_PAGE_VIEW_NAME = 'setPageViewName';
export const SET_USER_ID = 'setUserId';
export const START = 'start';
export const WRAP_LOGGER = 'wrapLogger';
export const MEASURE = 'measure';
export const CONSENT = 'consent';